import { useRef } from 'react';

function useExecutionDelay(startFn, cleanFn, delayTime) {
  var startTimer = useRef();
  var closeTimer = useRef();

  var startFunction = function startFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(closeTimer.current);
    startTimer.current = setTimeout(function () {
      return startFn.apply(void 0, args);
    }, delayTime);
  };

  var cleanFunction = function cleanFunction() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    clearTimeout(startTimer.current);
    closeTimer.current = setTimeout(function () {
      return cleanFn.apply(void 0, args);
    }, 30);
  };

  return [startFunction, cleanFunction];
}

export default useExecutionDelay;
//# sourceMappingURL=useExecutionTimer.js.map
